import { getContrastColor } from '@infinex/ui-utils/color';

import { envOverrides } from '../../env';
import {
  DEFAULT_CHAIN_LIMITS,
  defaultServices,
  defaultSwidge,
} from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const fogo = {
  displayName: 'Fogo',
  runtime: 'svm',
  isSupported: true,
  isMainnet: true,
  isReleased: true,
  orderPriority: 17,

  decoration: {
    color: '#FF3D00',
    contrastColor: getContrastColor('#FF3D00'),
  },
  features: {
    wallet: { supported: true, import: true },
    vault: {
      supported: false,
      ccqRecovery: false,
    },
  },
  connectivity: {
    rpc: {
      rpcUrl: ['https://mainnet.fogo.io'],
    },
    blockExplorers: {
      primary: {
        base: 'https://fogoscan.com',
        token: 'https://fogoscan.com/address',
      },
    },
  },
  environments: {
    dev: true,
    test: true,
    staging: true,
    prod: true,
  },
  swidge: defaultSwidge(),
  services: {
    ...defaultServices(),
    codex: {
      networkId: 150601,
      nativeLiquidityAddress: 'So11111111111111111111111111111111111111112',
    },
  },
  limits: envOverrides(DEFAULT_CHAIN_LIMITS, {}),
} as const satisfies AllChainConfig<'svm', true>;
